import { useCallback, useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import UserContext, { useIsLoggedIn } from '~/context/common/UserContext';
import ModalContext from '~/context/srp/ModalContext';
import { useOpenAccountModal } from '~/hooks/common/accountModal/useAccountModal';
import { SearchDispatcherEvent } from '~/native/srp/dispatchers/constants';

export default function useLogInAndSaveSearch() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { setAccountModalOpen, setSaveSearchModalOpen } =
    useContext(ModalContext);
  const { triggerFetchUserProfile } = useContext(UserContext);

  const isLoggedIn = useIsLoggedIn();
  const openAccountModal = useOpenAccountModal();

  const handleOpenModal = useCallback(() => {
    setSaveSearchModalOpen(true, appliedFilters);
  }, [appliedFilters, setSaveSearchModalOpen]);

  const onSuccess = useCallback(() => {
    setAccountModalOpen(false);
    triggerFetchUserProfile();
    handleOpenModal();
  }, [handleOpenModal, setAccountModalOpen, triggerFetchUserProfile]);

  return useCallback(() => {
    if (isLoggedIn) {
      handleOpenModal();

      return;
    }

    openAccountModal({
      callerIdentifier: 'SearchAlert',
      displayTitle: 'SAVE YOUR SEARCH',
      nativeOptions: { eventDispatch: SearchDispatcherEvent.SaveSearch },
      onSuccess
    });
  }, [isLoggedIn, onSuccess, openAccountModal, handleOpenModal]);
}
